import React, { Component, ReactElement } from 'react';
import Modal from '../modal';
import ReactDOM from 'react-dom';
import './index.less';

export interface ConfirmProps {
  container: HTMLElement;
  destroy: Function;
  type: number;
  cancelText: string;
  confirmText: string;
  cancelCbk: Function;
  confirmCbk: Function;
  children?: any;
}

class Confirm extends Component<ConfirmProps, any> {
  static defaultOptions = {
    type: 1, // 1： 两个按钮，2：一个确认按钮
    cancelText: '取消',
    confirmText: '确定',
    header: '',
    content: 'I am confirm man',
    cancelCbk: (destroy): void => destroy(),
    confirmCbk: (destroy): void => destroy()
  };
  static open = function (content: string | Component, options?: any): void {
    const div = document.createElement('div');
    document.body.appendChild(div);
    if (!options) {
      options = Confirm.defaultOptions;
    } else {
      options = { ...Confirm.defaultOptions, ...options };
    }
    function destroy(): void {
      const unmountRes = ReactDOM.unmountComponentAtNode(div);
      if (unmountRes && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }
    ReactDOM.render(
      <Confirm
        // style={{ borderRadius: '0px' }}
        container={div}
        {...options}
        destroy={(): void => destroy()}
      >
        <div className="xp-confirm-content">
          {options.header ? (
            <div className="xp-confirm-header">{options.header}</div>
          ) : (
            ''
          )}
          <div className="xp-confirm-p">
            <>
              {content}
            </>
          </div>
        </div>
      </Confirm>,
      div
    );
  };
  render(): ReactElement {
    const type = this.props.type;
    const { destroy } = this.props;
    let btns;
    if (type === 1) {
      btns = (
        <div className="xp-confirm-btns">
          <button
            className="xp-cancel-btn"
            onClick={(): void => {
              this.props.cancelCbk(destroy);
            }}
          >
            {this.props.cancelText}
          </button>
          <button
            className="xp-confirm-btn"
            onClick={(): void => {
              this.props.confirmCbk(destroy);
            }}
          >
            {this.props.confirmText}
          </button>
        </div>
      );
    } else if (type === 2) {
      btns = (
        <div className="xp-confirm-btns">
          <button
            className={'xp-confirm-btn-only'}
            onClick={(): void => {
              this.props.confirmCbk(destroy);
            }}
          >
            {this.props.confirmText}
          </button>
        </div>
      );
    }
    return ReactDOM.createPortal(
      <Modal
        cls={{
          modal: 'xp-confirm-modal'
        }}
      >
        {this.props.children}
        {btns}
      </Modal>,
      this.props.container
    );
  }
}

export default Confirm;
